module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_plan_show_bg_05-1affaea2c8ceb11790659630a4109471.png";